var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown" }, [
    _c(
      "ol",
      { staticClass: "list" },
      _vm._l(_vm.sortOptions, function (option) {
        return _c(
          "li",
          {
            key: option.key,
            staticClass: "item",
            class: { selected: option.key === _vm.selectedSort },
            on: {
              click: function ($event) {
                return _vm.$emit("sort-list-item-click", option)
              },
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "button",
                class: { active: option.key === _vm.selectedSort },
                attrs: { type: "button" },
              },
              [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }